import { I18N_DE } from '@/i18n/de';

type ApiValidationError = {
  statusCode: 400;
  message: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function getApiError(error: Error) {
  const apiError: { message?: string; error?: string; statusCode?: number } = {};

  if ('message' in error && error.message && typeof error.message === 'string') {
    Object.assign(apiError, { message: error.message });
  }
  if ('error' in error && error.error && typeof error.error === 'string') {
    Object.assign(apiError, { error: error.error });
  }
  if ('statusCode' in error && error.statusCode && typeof error.statusCode === 'number') {
    Object.assign(apiError, { statusCode: error.statusCode });
  }

  return apiError;
}

export function getApiValidationError(error: unknown): ApiValidationError | undefined {
  if (!isRecord(error) || error.statusCode !== 400 || !Array.isArray(error.message)) {
    return undefined;
  }

  const validationMessages = error.message.flatMap((message) => {
    if (!isRecord(message) || !isRecord(message.constraints)) {
      return [];
    }

    return Object.values(message.constraints).filter(
      (constraint): constraint is string => typeof constraint === 'string',
    );
  });

  if (validationMessages.length === 0) {
    return undefined;
  }

  return {
    statusCode: 400,
    message: validationMessages
      .map((validationMessage) =>
        validationMessage === 'email must be unique' ? 'Die E-Mail Adresse existiert bereits.' : validationMessage,
      )
      .join(', '),
  };
}

export function getErrorStatusText(error: Error) {
  if ('statusCode' in error && error.statusCode && typeof error.statusCode === 'number') {
    if (Object.keys(I18N_DE.ErrorCode).includes(error.statusCode.toString())) {
      return I18N_DE.ErrorCode[error.statusCode as keyof (typeof I18N_DE)['ErrorCode']];
    }

    return 'Fehler';
  }

  return 'Unbekannter Fehler';
}
